import React, { type FC } from "react";
import { Desktop, Mobile, useTrackElement } from "@edreamsodigeo/frontend-core";
import { Box, SystemModal } from "@edreamsodigeo/prisma-design-system";

import { DATAMESH_ONLOAD_EVENT } from "./config/tracking";
import type { UserVerificationSystemModalProps } from "./contract";

const UserVerificationSystemModal: FC<UserVerificationSystemModalProps> = ({
  isOpen,
  children,
}) => {
  const trackDisplayRef = useTrackElement(["display"], DATAMESH_ONLOAD_EVENT);
  return (
    <Box ref={trackDisplayRef}>
      <Desktop>
        <SystemModal open={isOpen} sx={{ width: "394px" }}>
          {children}
        </SystemModal>
      </Desktop>
      <Mobile>
        <SystemModal open={isOpen} modalSize="small">
          {children}
        </SystemModal>
      </Mobile>
    </Box>
  );
};

export default UserVerificationSystemModal;
